import { defineStore } from "pinia";
import api from "@/services/api";

export const useChildrenStore = defineStore("children", {
    state: () => ({
        children: [],
        selectedChild: null,
        loading: false,
        fetchedAt: 0,
    }),

    persist: true,

    actions: {
        async fetchChildrenList(user_id, force = false) {
            try {
                const now = Date.now();
                if (!force && this.children && now - this.fetchedAt < 60_000) return; // cache 1 menit

                const response = await api.get(`/child-list`, {
                    params: {
                        user_id: user_id,
                    },
                });
                
                const data = response.data.data;

                this.children = data;

                if (!this.selectedChild && data.length > 0) {
                    this.selectedChild = data[0];
                } else {
                    const existingChild = data.find(child => child.id === this.selectedChild?.id);
                    this.selectedChild = existingChild || data[0];
                }

                this.fetchedAt = now;
            } catch (error) {
                console.error("Error fetching children list:", error);
            } finally {
                this.loading = false;
            }
        },
        selectChild(child_id) {
            const child = this.children.find(c => c.id === child_id);
            if (!child) {
                console.error("Child not found:", child_id);
                return;
            }
            this.selectedChild = child;
        },
        updateWalletLimit(userId, limit) {
            try {
                const res = api.post(`/wallet/set-wallet-limit/${userId}`, {walletLimit: limit})
                return res
            } catch (error) {
                console.error("Error setting wallet limit:", error);
                throw error
            }
        },
        setFetchForced() {
            this.fetchedAt = 0; // Reset fetchedAt to force refetch
        },
        reset() {
            this.children = [];
            this.selectedChild = null;
            this.loading = false;
            this.fetchedAt = 0;
        }
    },
});